import { TimelineEventType } from 'adv-lib/src/v2/interface/chat'
import { SPORT_ID } from 'adv-protocol/src/GameCommon'

export enum CHEER_FOR_TEAM_CONTENTS_TYPE {
  TEXT_ONLY, EMOTICON, IMAGE, BET_HISTORY, AUTO_GENERATE_BET_HISTORY,
}

export const SPORT_TALK_TIMELINE_FILTER: Record<number, string[]> = {
  [SPORT_ID.SOCCER]: [
    TimelineEventType.MATCH_STARTED,
    TimelineEventType.PERIOD_START,
    TimelineEventType.SCORE_CHANGE,
    TimelineEventType.CORNER_KICK,
    TimelineEventType.YELLOW_CARD,
    TimelineEventType.RED_CARD,
    TimelineEventType.YELLOW_RED_CARD,
    TimelineEventType.BREAK_START,
    TimelineEventType.MATCH_ENDED,
  ],
  [SPORT_ID.BASKETBALL]: [
    TimelineEventType.MATCH_STARTED,
    TimelineEventType.PERIOD_START,
    TimelineEventType.BREAK_START,
    TimelineEventType.MATCH_ENDED,
  ],
  [SPORT_ID.BASEBALL]: [
    TimelineEventType.MATCH_STARTED,
    TimelineEventType.PERIOD_START,
    TimelineEventType.SCORE_CHANGE,
    TimelineEventType.MATCH_ENDED,
  ],
  [SPORT_ID.ICE_HOCKEY]: [
    TimelineEventType.MATCH_STARTED,
    TimelineEventType.PERIOD_START,
    TimelineEventType.SCORE_CHANGE,
    TimelineEventType.BREAK_START,
    TimelineEventType.MATCH_ENDED,
  ],
  [SPORT_ID.TABLE_TENNIS]: [
    TimelineEventType.MATCH_STARTED,
    TimelineEventType.PERIOD_START,
    TimelineEventType.BREAK_START,
    TimelineEventType.MATCH_ENDED,
  ],
  [SPORT_ID.VOLLEYBALL]: [
    TimelineEventType.MATCH_STARTED,
    TimelineEventType.PERIOD_START,
    TimelineEventType.BREAK_START,
    TimelineEventType.MATCH_ENDED,
  ],
}
